export default () => {

  /**
   * タッチイベントの振り分け
   * @type {Object}
   */
  const EVENT = {}
  if ('ontouchstart' in window) {
    EVENT.TOUCH_START = 'touchstart'
    EVENT.TOUCH_MOVE = 'touchmove'
    EVENT.TOUCH_END = 'touchend'
  } else {
    EVENT.TOUCH_START = 'mousedown'
    EVENT.TOUCH_MOVE = 'mousemove'
    EVENT.TOUCH_END = 'mouseup'
  }
  
  window.addEventListener('DOMContentLoaded', () => {

    const header = document.getElementsByClassName('l-header')[0];
    const footer = document.getElementsByClassName('l-footer')[0];

    let prevTouchPosition = false;;
    let prevScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    let isRunning = true;

    window.addEventListener(EVENT.TOUCH_START, e => {
      prevTouchPosition = {};
      prevTouchPosition['top'] = e.pageY ? e.pageY : e.changedTouches[0].pageY;
    });
    window.addEventListener(EVENT.TOUCH_MOVE, e => {
      if (prevTouchPosition) {
        let currentPageY = e.pageY ? e.pageY : e.changedTouches[0].pageY;
        if ('top' in prevTouchPosition) {
          if (prevTouchPosition.top - currentPageY >= 0) {
            document.body.classList.add('is-scrollUp');
          } else if (prevTouchPosition.top - currentPageY < 0) {
            document.body.classList.remove('is-scrollUp');
          }
        }
      }
    });
    window.addEventListener(EVENT.TOUCH_END, e => {
      prevTouchPosition = false;
    });
    window.addEventListener('scroll', () => {
      if (isRunning) {
        isRunning = false;
        requestAnimationFrame(function () {
          isRunning = true;
          const winScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          onScroll (winScrollTop);
          prevScrollTop = winScrollTop;
        })
      }
    });

    onScroll(document.documentElement.scrollTop || document.body.scrollTop)
    function onScroll (winScrollTop) {
      if (winScrollTop > 0) {
        if (winScrollTop - prevScrollTop >= 0) {
          document.body.classList.add('is-scrollUp');
        } else if (winScrollTop - prevScrollTop < 0) {
          document.body.classList.remove('is-scrollUp');
        }
        if (winScrollTop >= 150 && window.innerHeight - footer.getBoundingClientRect().top < 0) {
          document.body.classList.remove('is-pageTopHide');
        } else {
          document.body.classList.add('is-pageTopHide');
        }
      } else {
        document.body.classList.remove('is-scrollUp');
        document.body.classList.add('is-pageTopHide');
      }
      if (winScrollTop > window.innerHeight) {
        document.body.classList.add('is-headerFixed');
      } else {
        document.body.classList.remove('is-headerFixed');
      }
    }

    /**
     * toggle menu
     */
    const toggleMenuTriggers = document.querySelectorAll('.js-toggleMenu');
    toggleMenuTriggers.forEach(toggleMenuTrigger => {
      toggleMenuTrigger.addEventListener('click', e => {
        if (document.body.classList.contains('is-menuActive')) {
          document.body.classList.remove('is-menuActive');
        } else {
          document.body.classList.add('is-menuActive');
        }
      });
    });

    const closeMenuTriggers = document.querySelectorAll('.js-closeMenu');
    closeMenuTriggers.forEach(closeMenuTrigger => {
      closeMenuTrigger.addEventListener('click', e => {
        document.body.classList.remove('is-menuActive');
      });
    });

    /**
     * open | close dialogs
     */
    const openDialogTriggers = document.querySelectorAll('.js-openDialog');
    const dialogElements = document.querySelectorAll('.js-dialog');
    openDialogTriggers.forEach(openDialogTrigger => {
      const targetElement = document.getElementById(openDialogTrigger.getAttribute('aria-controls'));
      openDialogTrigger.addEventListener('click', e => {
        closeDialogs();
        targetElement.classList.add('is-active');
      });
    });

    const closeDialogTriggers = document.querySelectorAll('.js-closeDialog');
    closeDialogTriggers.forEach(closeDialogTrigger => {
      closeDialogTrigger.addEventListener('click', e => {
        closeDialogs();
      });
    })
    
    function closeDialogs () {
      dialogElements.forEach(dialogElement => {
        dialogElement.classList.remove('is-active');
      });
    }

  });

}